import enLocale from './en';
import esCLLocale from './es-CL';

const messages = {
  en: enLocale,
  'es-CL': esCLLocale,
};

export default { messages };
